module.exports = __webpack_public_path__ + "static/media/blueprism.33b98dfb.png";